/**
 * Auth Adapter
 * Transforms authentication-related data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type { LoginDto, LoginResponseDto, UserAccountsResponseDto } from '@/types';

export class AuthAdapter extends BaseAdapter {
  /**
   * Adapts login request payload
   */
  static toLoginRequest(email: string, password: string): LoginDto {
    return {
      email: email.trim().toLowerCase(),
      password
    };
  }

  /**
   * Adapts login response to application format
   */
  static fromLoginResponse(dto: LoginResponseDto) {
    return {
      accessToken: dto.token,
      refreshToken: dto.refreshToken,
      user: {
        id: dto.user.id,
        email: dto.user.email,
        name: dto.user.name,
        accountId: dto.user.accountId,
        accountName: dto.user.accountName,
        subDomain: dto.user.subDomain,
        customAttributes: dto.user.customAttributes || {}
      }
    };
  }

  static fromUserAccountsResponse(dto: UserAccountsResponseDto) {
    return {
      currentAccountId: dto.currentAccountId,
      accounts: dto.accounts.map((a) => ({
        id: a.id,
        name: a.name,
        subDomain: a.subDomain,
        role: a.role,
        refreshThreshold: a.refreshThreshold
      }))
    };
  }

  static toSwitchAccountRequest(accountId: number) {
    return { accountId };
  }
}
